module.exports = __webpack_public_path__ + "static/media/2023-Sub-Exclusive-Feature-Banner-md@1x.b63ae64c.webp";